import React from 'react';
import PrivacyScreen from './components/privacy';

function Contact() {
  return <PrivacyScreen />;
}

export default Contact;
